let EditDict = {
  b2b_enabled_status: [
    {
      id: "1008",
      label: "Yes",
      value: "0"
    },
    {
      id: "1009",
      label: "No",
      value: "1"
    }
  ],
  area_list: [
    { id: "Xiaocha Township", label: "Xiaocha Township" },
    { id: "Jiaocha Township", label: "Jiaocha Township" },
    { id: "Gucheng Town", label: "Gucheng Town" },
    { id: "Fengzhuang Township", label: "Fengzhuang Township" },
    { id: "Chengyang Township", label: "Chengyang Township" },
    { id: "Honghe Town", label: "Honghe Town" },
    { id: "Luowa Township", label: "Luowa Township" },
    { id: "Xinji Township", label: "Xinji Township" },
    { id: "Wangwa Town", label: "Wangwa Town" },
    { id: "Mengyuan Township", label: "Mengyuan Township" },
    { id: "Baiyang Town", label: "Baiyang Town" },
    { id: "Caomiao Township", label: "Caomiao Township" }
  ],
  trace_service_status: [
    { label: "In Use", value: "0" },
    { label: "Deactivated", value: "1" }
  ],
  trace_call_status: [
    { label: "Failed", value: "0" },
    { label: "Normal", value: "1" }
  ],
  trace_call_method: [
    { label: "GET", value: "0" },
    { label: "POST", value: "1" }
  ],
  trace_timing_status: [
    { label: "No", value: "0" },
    { label: "Yes", value: "1" }
  ],
  trace_param_type: [
    { label: "Latest Time", value: "0" },
    { label: "Text", value: "1" }
  ],
  base_certificat: [
    { label: "Organic Certified Base", value: "0", disable: false },
    { label: "Green Certified Base", value: "1", disable: false },
    { label: "Model Demonstration Base", value: "2", disable: false },
    { label: "Other", value: "3", disable: false }
  ],
  base_level: [
    { label: "National Level", value: 1 },
    { label: "Provincial Level", value: 2 },
    { label: "Municipal Level", value: 3 },
    { label: "County Level", value: 4 },
    { label: "Other", value: 5 }
  ],
  base_hezuo_type: [
    { label: "Planting Type", value: 1 },
    { label: "Processing Type", value: 2 },
    { label: "Integrated Industry Type", value: 3 },
    { label: "Social Service Type", value: 4 }
  ],
  base_plant_type: [
    { label: "Cooperative", value: 1 },
    { label: "Large-scale Farmer (Over 20 Mu)", value: 2 },
    { label: "Small-scale Farmer", value: 3 }
  ],
  base_process_type: [
    { label: "Pit Removal", value: 1 },
    { label: "Slicing", value: 2 },
    { label: "Impurity Removal", value: 3 },
    { label: "Washing", value: 4 },
    { label: "Other", value: 5 }
  ],
  base_social_type: [
    { label: "Agricultural Machinery", value: 1 },
    { label: "Agricultural Technology", value: 2 },
    { label: "Agricultural Inputs", value: 3 }
  ],
  base_industry_type: [
    { label: "Tourist Garden", value: 1 },
    { label: "Picking Garden", value: 2 },
    { label: "Rural Homestay", value: 3 }
  ]
};

module.exports = EditDict;